import React from "react";
import { NavLink } from "react-router-dom";

export default function NavItem({
  to,
  children,
  external,
  className = "",
  highlighted = false,
  button = false,
  closeNav,
}) {
  const isDropdown = Array.isArray(children);

  const handleCloseNav = () => {
    if (closeNav) closeNav();
  };

  if (external) {
    return (
      <li
        className={`menu-item ${className} ${highlighted ? "btn-red" : ""} ${button ? "menu-button" : ""}`}
      >
        <a href={to} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      </li>
    );
  }

  return (
    <li
      className={`menu-item ${className} ${isDropdown ? "has-dropdown" : ""} ${button ? "menu-button" : ""}`}
    >
      {to ? (
        <NavLink
          to={to}
          className={({ isActive }) =>
            `${isActive ? "menu-item-active" : ""} ${
              highlighted ? "btn-red" : ""
            }`
          }
          onClick={handleCloseNav}
        >
          {isDropdown ? children[0] : children}
          {isDropdown && <i className="fa fa-chevron-down"></i>}
        </NavLink>
      ) : (
        <span className="menu-title">
          {children[0]}
          {isDropdown && <i className="fa fa-chevron-down"></i>}
        </span>
      )}
      {isDropdown && (
        <div className="dropdown-container">
          <div className="dropdown-list">{children.slice(1)}</div>
        </div>
      )}
    </li>
  );
}
